import React from 'react';
import { Popup } from 'react-map-gl';
import styles from './popup.less';
import { CloseOutlined } from '@ant-design/icons';
import { Dayjs } from 'dayjs';
import waterClarityLegend from './water_clarity_legend_tooltip.svg';
export interface WaterClarityPopupInfo {
  lat: number;
  lng: number;
  waterClarity: number;
}

interface WaterClarityPopupProps {
  onClose: () => void;
  waterClarityPopupInfo: WaterClarityPopupInfo;
  waterClarityWaterbodyName: string;
  waterClarityDisplayedDate: Dayjs;
}

export const WaterClarityPopup = React.memo((props: WaterClarityPopupProps) => {
  const { onClose, waterClarityPopupInfo, waterClarityWaterbodyName, waterClarityDisplayedDate } =
    props;
  return (
    <>
      {waterClarityPopupInfo && (
        <Popup
          longitude={waterClarityPopupInfo.lng}
          latitude={waterClarityPopupInfo.lat}
          onClose={onClose}
          key={`${waterClarityPopupInfo.lng}-${waterClarityPopupInfo.lat}`} // for some reason i could only render 1 popup at a time without this
          className={styles.popup}
          closeButton={false}
        >
          <div className={styles.content}>
            <header className={styles.header}>
              <span>{waterClarityWaterbodyName}</span>
              <span className={styles.close} onClick={onClose}>
                <span className={styles.closeIcon}>
                  <CloseOutlined />
                </span>
              </span>
            </header>
            <div className={styles.body}>
              <strong>Water clarity at this point</strong>
              <br />
              <span className={styles.clarityBlurb}>
                <strong>{waterClarityPopupInfo.waterClarity} of 10</strong> as of{' '}
                {waterClarityDisplayedDate?.format('M/DD/YY')}
              </span>
              <div className={styles.legend}>
                <span
                  style={{
                    transform: `translateX(${waterClarityPopupInfo.waterClarity * 15.7}px)`,
                  }}
                >
                  {waterClarityPopupInfo.waterClarity}
                </span>
                <img src={waterClarityLegend} alt="visual scale of temperature legend" />
              </div>
              <div className={styles.legendWords}>
                <span>CLEAR</span>
                <span>MURKY</span>
              </div>
            </div>
          </div>
        </Popup>
      )}
    </>
  );
});
